/**
 * @generated SignedSource<<2ee9d1eb12a28fb1d0ef57cca036c722>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UsersWhoMadeContentNodeTable_Refetch$variables = {
  after?: string | null | undefined;
  contentNodeId?: string | null | undefined;
  filterByFirstName?: string | null | undefined;
  filterByLastName?: string | null | undefined;
  first?: number | null | undefined;
};
export type UsersWhoMadeContentNodeTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UsersWhoMadeContentNodeTable_Fragment">;
};
export type UsersWhoMadeContentNodeTable_Refetch = {
  response: UsersWhoMadeContentNodeTable_Refetch$data;
  variables: UsersWhoMadeContentNodeTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentNodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByFirstName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByLastName"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "contentNodeId",
    "variableName": "contentNodeId"
  },
  {
    "kind": "Variable",
    "name": "filterByFirstName",
    "variableName": "filterByFirstName"
  },
  {
    "kind": "Variable",
    "name": "filterByLastName",
    "variableName": "filterByLastName"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountCode",
        "storageKey": null
      }
    ],
    "type": "InfectopharmUserExtension",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersWhoMadeContentNodeTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "UsersWhoMadeContentNodeTable_Fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersWhoMadeContentNodeTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UsersListAdminSchema",
            "kind": "LinkedField",
            "name": "UsersList",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "AllUsers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": (v3/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "userExtensionKind",
                                "value": "InfectopharmUserExtension"
                              }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": (v3/*: any*/),
                            "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "contentNodeId",
                  "filterByFirstName",
                  "filterByLastName"
                ],
                "handle": "connection",
                "key": "UsersWhoMadeContentNodeTable_AllUsers",
                "kind": "LinkedHandle",
                "name": "AllUsers"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84c61139da2f34a204112cd232aa9fdb",
    "id": null,
    "metadata": {},
    "name": "UsersWhoMadeContentNodeTable_Refetch",
    "operationKind": "query",
    "text": "query UsersWhoMadeContentNodeTable_Refetch(\n  $after: String\n  $contentNodeId: ID\n  $filterByFirstName: String\n  $filterByLastName: String\n  $first: Int = 10\n) {\n  ...UsersWhoMadeContentNodeTable_Fragment_2zKqJw\n}\n\nfragment UserActionColumn_NodeFragment on User {\n  id\n  ...UserContentSubmissionDialog_UserFragment\n}\n\nfragment UserContentSubmissionDialog_UserFragment on User {\n  id\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n    }\n  }\n}\n\nfragment UsersWhoMadeContentNodeTable_Fragment_2zKqJw on Query {\n  Admin {\n    UsersList {\n      AllUsers(first: $first, after: $after, contentNodeId: $contentNodeId, filterByFirstName: $filterByFirstName, filterByLastName: $filterByLastName) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            extensions {\n              __typename\n              ... on InfectopharmUserExtension {\n                firstName\n                lastName\n                accountCode\n              }\n            }\n            ...UserContentSubmissionDialog_UserFragment\n            ...userNameColumn_Fragment\n            ...UserActionColumn_NodeFragment\n            ...accountCodeColumn_Fragment\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment accountCodeColumn_Fragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      accountCode\n    }\n  }\n}\n\nfragment userNameColumn_Fragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8239aa56a85360eba3ee8798bea9dda";

export default node;
